export const defaultFilters = {
  page: 1,
  per_page: 25,
  page_size: 25,
  pageSize: 25
}

export function defaultFiltersMultipleValues(
  param: unknown,
  isNumber: true
): number[] | undefined
export function defaultFiltersMultipleValues(
  param: unknown,
  isNumber?: false
): string[] | undefined
export function defaultFiltersMultipleValues(
  param: unknown,
  isNumber = false
): number[] | string[] | undefined {
  if (!param) return undefined

  const values = (Array.isArray(param) ? param : [param])
    .flatMap((value) => String(value).split(','))
    .map((value) => value.trim())
    .filter(Boolean)

  if (!values.length) return undefined

  return isNumber
    ? values.map(Number).filter((value) => Number.isFinite(value))
    : values
}

export const getSingleFilterStringValue = (param: unknown) =>
  defaultFiltersMultipleValues(param)?.[0]

export const getSingleFilterNumberValue = (param: unknown) =>
  defaultFiltersMultipleValues(param, true)?.[0]

/**
 * Converts all camelCase keys in an object to snake_case keys.
 * Only transforms keys with more than one word.
 * Example: { aKeyWithCamelCase: 1, foo: 2 } => { a_key_with_camel_case: 1, foo: 2 }
 */
export const keysToSnakeCase = <T extends Record<string, unknown>>(
  obj: T
): Record<string, unknown> =>
  Object.entries(obj).reduce(
    (acc, [key, value]) => {
      const snakeKey = /[A-Z]/.test(key)
        ? key.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase()
        : key
      acc[snakeKey] = value
      return acc
    },
    {} as Record<string, unknown>
  )
